import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@vendure/admin-ui/core';

import {ChartComponent} from './chart.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  exports: [ChartComponent],
  declarations: [ChartComponent],
  providers: [],
})
export class ChartModule {}
